import * as React from "react";
import {cx} from "emotion";

import "./component-info.scss";

import {Badge}         from "@Common/ui-components/heavy/common/design2/badge/badge";
import {DivCollapser1} from "@Xpresso/routes/common/components/div-collapser-1/div-collapser-1";

export const ComponentInfo = ({className, templateOptions, isPickPack, component, isInternalUser}) => templateOptions && (
    <div className={cx("component-info-r8y", className)}>
        <div className="header">
            <div className="title">
                {isInternalUser && <>
                    {Badge({
                        color: "blue-inverse",
                        text: templateOptions.sku.front,
                        xdQaName: "Template id",
                    })}
                    <div className="name" />
                </>}
                <div className="name" xd-qa-type="text" xd-qa-name={templateOptions?.name}>{templateOptions?.name}</div>
                {(
                    (isPickPack && !component.selections?.options?.some((option) => option?.error)) ||
                    (!isPickPack && !component.selections?.options?.some((option) => option?.error) && component?.itemThumbnails?.length > 0)
                ) && (
                    Badge({
                        color: "green",
                        text: "Ready",
                        xdQaName: "Ready",
                    })
                )}
            </div>
            <div className="production-time">
                <div className="label" xd-qa-type="label" xd-qa-name="Quantity">
                    Quantity included in Kit: &nbsp;
                    <div className="value" xd-qa-type="text" xd-qa-name="Quantity">
                        {component?.selections?.quantity || 1}
                    </div>
                </div>
            </div>
        </div>
        {!isPickPack && !(component?.itemThumbnails?.length > 0) && (
            <div className="customize-section">
                <div className="warning" xd-qa-type="label" xd-qa-name="Warning">
                    This kit item requires customization before you can proceed to checkout.
                </div>
            </div>
        )}
        {isPickPack && component.selections?.options?.some((option) => option?.error) && (
            <div className="customize-section">
                <div className="warning" xd-qa-type="label" xd-qa-name="Warning">
                    This kit item requires options to be selected before you can proceed to checkout.
                </div>
            </div>
        )}


        {Description({description:templateOptions?.description})}

        {FinishedSize({product:templateOptions?.product})}

    </div>
);

const Description = ({description}) => DivCollapser1({
    expandedBottomPadding: 25,
    collapsedHeight: 48,
    className: "description",
    renderContent: (ref) => (
        <div className="text" ref={ref} xd-qa-type="text" xd-qa-name="Description">
            {description}
        </div>
    )
});

const FinishedSize = ({product}) => product && (
    <div className="sizes">
        {product.finishedWidth != 0 && product.finishedHeight != 0 && (
            <div className="finished-size">
                <div className="label" xd-qa-type="label" xd-qa-name="Finished Size">Finished Size:</div>
                <div className="value" xd-qa-type="text" xd-qa-name="Finished Size">{product.finishedWidth}{`"` }{" x "}{product.finishedHeight}{`"`}</div>
            </div>
        )}

        {(
            (product.finishedWidth != 0 && product.finishedHeight != 0) &&
            (product.flatWidth != product.finishedWidth || product.flatHeight != product.finishedHeight )
        ) && (
            <div className="finished-size">
                <div className="label" xd-qa-type="label" xd-qa-name="Flat Size">Flat Size:</div>
                <div className="value" xd-qa-type="text" xd-qa-name="Flat Size">{product.flatWidth}{`"` }{" x "}{product.flatHeight}{`"`}</div>
            </div>
        )}
    </div>
);

const AvailableStock = ({stock}) => (
    <div className="production-time">
        <div className="label" xd-qa-type="label" xd-qa-name="Available Quantity">
            Available Quantity:
        </div>
        <div className="value" xd-qa-type="text" xd-qa-name="Available Quantity">
            {stock}
        </div>
    </div>
);
